import { enumToEnumNames } from '@commonClient2/services/enums';
// eslint-disable-next-line import/prefer-default-export
export const EmployeeBidProfileColumn = Object.freeze({
    Available: 0,
    Draft: 1,
    Submitted: 2,
    Closed: 3,
});
export const EmployeeBidProfileColumnNames = enumToEnumNames(EmployeeBidProfileColumn);
